import { Link } from '@tanstack/react-router';
import type { FakeUserDto } from '@upme/contracts';
import { Avatar, AvatarFallback, AvatarImage } from '@upme/ui/components/avatar';
import { Badge } from '@upme/ui/components/badge';
import { Button } from '@upme/ui/components/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@upme/ui/components/table';

interface Props {
  items: ReadonlyArray<FakeUserDto>;
  cityNameById: Map<string, string>;
}

export function FakesTable({ items, cityNameById }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-12" />
          <TableHead>Имя</TableHead>
          <TableHead>Город</TableHead>
          <TableHead>Discoverable</TableHead>
          <TableHead>Создан</TableHead>
          <TableHead className="w-32" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((u) => (
          <TableRow key={u.id}>
            <TableCell>
              <Avatar>
                {u.photoUrl ? <AvatarImage src={u.photoUrl} /> : null}
                <AvatarFallback>{(u.firstName ?? '?').slice(0, 1)}</AvatarFallback>
              </Avatar>
            </TableCell>
            <TableCell>{[u.firstName, u.lastName].filter(Boolean).join(' ') || '—'}</TableCell>
            <TableCell>{u.cityId ? (cityNameById.get(u.cityId) ?? '—') : '—'}</TableCell>
            <TableCell>
              {u.isDiscoverable ? (
                <Badge variant="default">on</Badge>
              ) : (
                <Badge variant="secondary">off</Badge>
              )}
            </TableCell>
            <TableCell>{new Date(u.createdAt).toLocaleDateString('ru')}</TableCell>
            <TableCell>
              <Button asChild variant="outline" size="sm">
                <Link to="/users/fakes/$fakeId" params={{ fakeId: u.id }}>
                  Открыть
                </Link>
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
